import React, { useEffect, useState } from 'react'
import { deliveryUserState, deliveryUserEnderecosState } from '../../store/recoilData'
import { useRecoilState } from 'recoil'
import {
    Avatar, Button, Card, Divider, Drawer, Flex, List, Input, Row, Col, Select, Typography, Space,
    Breadcrumb
} from 'antd'

import { useToasts } from 'react-toast-notifications'
import {
    getEnderecos, postEndereco, putEnderecoIsprincipal,
    deleteEndereco,
} from '../../services/bd/cardapioDigital'
import { LeftOutlined, MoreOutlined, StarFilled } from '@ant-design/icons'
import PLACEHOLDER from '../../img/placeholder.png'
import InputMask from 'react-input-mask';
import { apiviacep } from '../../services/api.service'
import dayjs from 'dayjs'


const { Option } = Select

//paramentros passados [showHeader, openEnderecos, setOpenEnderecos]
export const EnderecosCtrl = (props) => {

    // const [app, openAuth, setOpenAuth] = useOutletContext();
    const { addToast } = useToasts()
    const [userDelivery, setUserDelivery] = useRecoilState(deliveryUserState)
    const [loading, setLoading] = useState(false)

    const { openEnderecos, setOpenEnderecos, app } = props
    const [enderecos, setEnderecos] = useRecoilState(deliveryUserEnderecosState)

    const [openEndereco, setOpenEndereco] = useState(false)
    const [itemSelected, setItemSelected] = useState(undefined)

    const [openMore, setOpenMore] = useState(false)


    useEffect(() => {
        if (userDelivery) {
            loadEnderecos()
        }
    }, [])


    async function loadEnderecos() {
        try {
            if (userDelivery?.token) {
                const resp = await getEnderecos(userDelivery?.token)
                setEnderecos(resp)
            }

        } catch (error) {

        }
    }


    function validaEndereco() {
        if (!itemSelected?.streetName)
            return false
        if (!itemSelected?.district)
            return false
        return true
    }

    async function viacep(cep) {
        try {
            if (itemSelected.streetName === undefined || itemSelected.streetName?.trim() === '')
                var response = await apiviacep.get(cep.trim().concat('/json/'))
            itemSelected.streetName = response.data.logradouro
            itemSelected.district = response.data.bairro
            itemSelected.city = response.data.localidade
            itemSelected.state = response.data.uf
            itemSelected.complement = response.data.complemento
            setItemSelected({ ...itemSelected })
            //  console.log(response.data)
        } catch (error) {

        }
    }


    return <Flex vertical gap={5}>
        {props.showHeader && <Flex align='center' gap={5}>
            <LeftOutlined onClick={() => setOpenEnderecos(false)} />
            <Flex justify='center' flex={1}>
                <Breadcrumb items={[{ title: 'Perfil' }, { title: 'Endereços de Entrega' }]} />
            </Flex>
        </Flex>
        }
        {props.showHeader && <Divider style={{ marginTop: 5, marginBottom: 10 }} />}
        {enderecos.length === 0 && <Flex style={{ padding: 15 }} vertical>
            <Flex justify='center'> <Avatar src={PLACEHOLDER} size={'large'} /> </Flex>
            <Flex justify='center' style={{ color: '#474747ff', textAlign: 'center' }}>Você não adicionou nenhum endereço para entrega.</Flex>
        </Flex>
        }
        <Card bordered size='small'>
            <Flex vertical>
                {enderecos.length > 0 && <Flex justify='center' style={{ marginBottom: 8, fontWeight: 600 }}>Meus Endereços</Flex>}
                <Button
                disabled={!userDelivery && enderecos?.length > 0}
                type='primary' style={{ backgroundColor: app?.cor, marginBottom: 10 }}
                    onClick={() => {
                        if(!userDelivery && enderecos?.length > 0){
                            addToast('Não é possível adicionar novo endereço, você precisa se cadastrar para ter mais de um endereço registrado.', {
                                appearance:'warning', autoDismiss:true
                            })
                            return 
                        }
                        setItemSelected({
                            city: app?.cidade,
                            state: app?.uf,
                            district: app?.bairro
                        })
                        setOpenEndereco(true)
                    }}>Adicionar Endereço</Button>

                <List
                    size='small'
                    loading={loading}
                    bordered
                    dataSource={enderecos}
                    renderItem={(item, index) => {
                        return <List.Item
                            actions={[<MoreOutlined style={{ color: '#000' }} onClick={() => {
                                setItemSelected(item)
                                setOpenMore(true)
                            }} />]} >

                            <List.Item.Meta
                                avatar={<Avatar size={'small'} src={PLACEHOLDER} />}
                                title={"".concat(item.streetName, " ", item.streetNumber)}
                                description={<Flex vertical>
                                    <Flex>{item.district}</Flex>
                                    {item.isprincipal === 1 ? <Flex style={{ fontSize: '0.8em', color: 'royalblue' }}> Endereço de entrega </Flex> : ""}

                                </Flex>}
                            />
                            {<StarFilled style={{ color: item.isprincipal === 1 ? 'gold' : 'gray' }}
                                onClick={async () => {
                                    try {
                                        if (userDelivery?.token) {
                                            setLoading(true)
                                            await putEnderecoIsprincipal(userDelivery?.token, item)
                                            addToast("Definido novo endereço de entrega!", { autoDismiss: true, appearance: 'success' })
                                            loadEnderecos()
                                        } else {

                                        }
                                    } catch (error) {
                                        addToast(error.message, { autoDismiss: true, appearance: 'error' })
                                    }
                                    setLoading(false)
                                }} />}

                        </List.Item>
                    }}>

                </List>



            </Flex>
        </Card>



        {/*ENDEREÇO */}
        {itemSelected && <Drawer
            style={{ backgroundColor: 'whitesmoke' }}
            open={openEndereco}
            width={'100%'}
            title={null}
            closable={false}>
            <Flex vertical gap={5}>
                <Flex align='center' gap={5}>
                    <LeftOutlined onClick={() => {
                        setOpenEndereco(false)
                        setItemSelected(undefined)
                    }} />
                    <Flex flex={1} justify='center' style={{ color: '#000', fontWeight: 600 }} gap={5}>
                        <Flex>CADASTRO DE ENDEREÇO </Flex>
                    </Flex>
                </Flex>
                <Divider style={{ marginTop: 5, marginBottom: 10 }} />
                <Card size='small' bordered>
                    <Row gutter={[4, 8]} style={{ padding: 15 }}>
                        <Col span={6}>
                            <Flex justify='flex-end'>CEP</Flex>
                        </Col>
                        <Col span={18}>
                            <InputMask
                                mask="99999-999" maskChar=" "
                                inputMode='tel'
                                value={itemSelected.postalCode}
                                onBlur={() => {
                                    viacep(itemSelected.postalCode.trim().replace('-', '').replace('*', ''))
                                }}
                                onChange={(e) => {
                                    itemSelected.postalCode = e.target.value
                                    setItemSelected({ ...itemSelected })

                                }}>
                                {() => <Input style={{ paddingTop: 0, paddingBottom: 0 }} />}
                            </InputMask>
                        </Col>

                        <Col span={6}> <Flex justify='flex-end'>
                            <Typography.Text>
                                Endereço
                            </Typography.Text>

                        </Flex>
                        </Col>
                        <Col span={18}><Input size='small'
                            maxlength={100}
                            value={itemSelected.streetName}
                            onChange={(e) => {
                                itemSelected.streetName = e.target.value
                                setItemSelected({ ...itemSelected })
                            }} /></Col>
                        <Col span={6} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                            <Flex>
                                <Typography.Text>
                                    Número
                                </Typography.Text>

                            </Flex>
                        </Col>
                        <Col span={18}><Input size='small'
                            maxlength={45}
                            value={itemSelected.streetNumber}
                            onChange={(e) => {
                                itemSelected.streetNumber = e.target.value
                                setItemSelected({ ...itemSelected })
                            }} /></Col>

                        <Col span={6} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                            <Space>
                                <Typography.Text>
                                    Bairro
                                </Typography.Text>

                            </Space>
                        </Col>
                        <Col span={18}><Input size='small'
                            maxlength={45}
                            value={itemSelected.district}
                            onChange={(e) => {
                                itemSelected.district = e.target.value
                                setItemSelected({ ...itemSelected })
                            }} /></Col>

                        <Col span={6}> <Flex justify='flex-end'>Complemento</Flex></Col>
                        <Col span={18}><Input size='small'
                            value={itemSelected.complement}
                            maxlength={45}
                            onChange={(e) => {
                                itemSelected.complement = e.target.value
                                setItemSelected({ ...itemSelected })
                            }} /></Col>
                        <Col span={6} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>Cidade</Col>
                        <Col span={18}><Input size='small'
                            maxlength={50}
                            autoComplete="new-password"
                            value={itemSelected.city}
                            onChange={(e) => {
                                itemSelected.city = e.target.value
                                setItemSelected({ ...itemSelected })
                            }} /></Col>
                        <Col span={6}> <Flex justify='flex-end'>Referencia</Flex></Col>
                        <Col span={18}><Input size='small'
                            maxlength={50}
                            value={itemSelected.reference}
                            onChange={(e) => {
                                itemSelected.reference = e.target.value
                                setItemSelected({ ...itemSelected })
                            }} /></Col>
                        <Col span={6} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>UF</Col>
                        <Col span={18}>
                            <Select value={itemSelected.state} size={'small'}
                                style={{ width: 60 }}
                                onChange={(e) => { setItemSelected({ ...itemSelected, state: e }) }}>
                                <Option value={"AC"}>AC</Option>
                                <Option value={"AL"}>AL</Option>
                                <Option value={"AP"}>AP</Option>
                                <Option value={"AM"}>AM</Option>
                                <Option value={"BA"}>BA</Option>
                                <Option value={"CE"}>CE</Option>
                                <Option value={"DF"}>DF</Option>
                                <Option value={"ES"}>ES</Option>
                                <Option value={"GO"}>GO</Option>
                                <Option value={"MA"}>MA</Option>
                                <Option value={"MT"}>MT</Option>
                                <Option value={"MS"}>MS</Option>
                                <Option value={"MG"}>MG</Option>
                                <Option value={"PA"}>PA</Option>
                                <Option value={"PB"}>PB</Option>
                                <Option value={"PR"}>PR</Option>
                                <Option value={"PE"}>PE</Option>
                                <Option value={"PI"}>PI</Option>
                                <Option value={"RJ"}>RJ</Option>
                                <Option value={"RN"}>RN</Option>
                                <Option value={"RS"}>RS</Option>
                                <Option value={"RO"}>RO</Option>
                                <Option value={"RR"}>RR</Option>
                                <Option value={"SC"}>SC</Option>
                                <Option value={"SP"}>SP</Option>
                                <Option value={"SE"}>SE</Option>
                                <Option value={"TO"}>TO</Option>
                            </Select>
                        </Col>
                    </Row>
                    <Divider style={{ marginTop: 5, marginBottom: 10 }} />
                    <Flex justify='center' gap={15}>
                        <Button onClick={() => setOpenEndereco(false)}>  Voltar</Button>
                        <Button
                            disabled={!validaEndereco()}
                            loading={loading}
                            type='primary' style={{ backgroundColor: app?.cor }}
                            onClick={async () => {
                                try {
                                    console.log(userDelivery, itemSelected)
                                    if (userDelivery?.token) {
                                        setLoading(true)
                                        await postEndereco(userDelivery?.token, itemSelected)
                                        loadEnderecos()
                                        setItemSelected(undefined)
                                        setOpenEndereco(false)
                                    } else {
                                        let aux = JSON.parse(JSON.stringify(itemSelected))
                                        aux.isprincipal = 1                                        
                                        aux.address_id = -1 * parseInt(dayjs().format('YYYYMMDDHHmmss'))
                                        setEnderecos([aux])
                                        setItemSelected(undefined)
                                        setOpenEndereco(false)
                                        
                                    }
                                } catch (error) {
                                    addToast(error.message, { autoDismiss: true, appearance: 'error' })
                                }

                                setLoading(false)
                            }}>Salvar</Button>
                    </Flex>

                </Card>
            </Flex>
        </Drawer>
        }


        {/*MORE*/}
        {itemSelected &&
            <Drawer
                height={210}
                open={openMore}
                placement='bottom'
                onClose={() => setOpenMore(false)}
                closable={false}
                title={null}>
                <Flex gap={15} vertical style={{ padding: 15 }}>
                    <Flex style={{ color: '#000', fontWeight: 600 }} justify='center'>Escolha uma das opções</Flex>
                    <Flex justify='center'>O que deseja fazer com o endereço?</Flex>
                    <Button block onClick={() => {
                        setOpenMore(false)
                        setOpenEndereco(true)
                    }} type='primary' style={{ backgroundColor: app?.cor }}>Editar</Button>
                    <Button
                        loading={loading}
                        danger block
                        onClick={async () => {
                            try {
                                if (itemSelected.isprincipal === 1) {
                                   // console.log(dayjs().format('YYYYMMDDHHmmss'))
                                    addToast("Não é possivel excluir o endereço de entrega atual!", { autoDismiss: true, appearance: 'info' })
                                    return
                                }
                                setLoading(true)
                                if (userDelivery?.token)
                                    await deleteEndereco(userDelivery?.token, itemSelected)
                                else {
                                    console.log(dayjs().format('YYYYMMDDHHmmss'))
                                    let aux = enderecos.find(v=> v.address_id !== itemSelected.address_id) // JSON.parse(JSON.stringify(enderecos))
                                    setEnderecos(aux)
                                }
                                setOpenMore(false)
                                addToast('Endereço encluido com sucesso!', { appearance: 'success', autoDismiss: true })
                                loadEnderecos()
                            } catch (error) {
                                addToast(error.message, { autoDismiss: true, appearance: 'error' })
                            }
                            setLoading(false)
                        }}>Excluir</Button>
                </Flex>
            </Drawer>
        }

    </Flex>
}
